import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { PaperContainer } from '../../components/paper/paper-container';

export type PageContainerRootProps = PropsWithChildren;

/** @experimental In active development. Avoid using until further notice. */
export const PageContainerRoot = forwardRef<
  HTMLDivElement,
  PageContainerRootProps
>(({ children }, ref) => (
  <PaperContainer
    className="page-container-root"
    ref={ref}
    component="section"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: 3,
      p: 3,
    }}
  >
    {children}
  </PaperContainer>
));
